module.exports = __webpack_public_path__ + "images/emoji/unlock.18732ea6051683b03d80.png";